module.exports = __webpack_public_path__ + "static/media/clean-design.0f928231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clean-design.jpg
// module id = 916
// module chunks = 0